export const ELIMINATING_QUESTION_TYPES = {
  RADIO: 'radio',
  NUMBER: 'number',
  RANGE: 'range',
  CHOOSE: 'choose',
  TEXT: 'text',
}

export const ELIMINATING_QUESTION_MODES = {
  EQUAL: 'equal',
  LTE: 'lte',
  GTE: 'gte',
  SINGLE_VALUE: 'single_value',
  RANGE_VALUE: 'range_value',
  ALL: 'all',
  ANY: 'any',
}

export const NUMBER_MODES = {
  EQUAL: ELIMINATING_QUESTION_MODES.EQUAL,
  LTE: ELIMINATING_QUESTION_MODES.LTE,
  GTE: ELIMINATING_QUESTION_MODES.GTE,
}

export const RANGE_MODES = {
  SINGLE_VALUE: ELIMINATING_QUESTION_MODES.SINGLE_VALUE,
  RANGE_VALUE: ELIMINATING_QUESTION_MODES.RANGE_VALUE,
}

export const CHOICE_MODES = {
  ALL: ELIMINATING_QUESTION_MODES.ALL,
  ANY: ELIMINATING_QUESTION_MODES.ANY,
}
